import CircularProgress from "@material-ui/core/CircularProgress"
import Typography from "@material-ui/core/Typography"
import { Check } from "react-feather"
import { UserViewModel } from "../../api/user"
import { useGetEmailChangeRequestQuery } from "../../api"
import { alpha, Chip, useTheme } from "@material-ui/core"
import UpdateEmailDialog from "./UpdateEmailDialog"
import EmailChangeRequest from "./EmailChangeRequest"
import { useTranslations } from "./use-translations"

const UserEmailSetting = ({ user }: { user: UserViewModel }) => {
  const { data: emailChangeRequest, isLoading: isLoadingEmailChangeRequest } = useGetEmailChangeRequestQuery()
  const translations = useTranslations()
  const theme = useTheme()

  if (isLoadingEmailChangeRequest) return <CircularProgress />

  return (
    <>
      <Typography variant="subtitle1" style={{ marginBottom: 0 }}>
        {translations.email}
      </Typography>
      <Typography gutterBottom variant="subtitle1" style={{ fontWeight: 500, marginBottom: 24 }}>
        {user.email}
        <Chip
          label={translations.verified}
          icon={<Check size={16} />}
          size="small"
          color="secondary"
          style={{
            marginLeft: 8,
            backgroundColor: alpha(theme.palette.success.main, 0.1),
            color: theme.palette.success.dark,
          }}
        />
      </Typography>

      {emailChangeRequest ? (
        <EmailChangeRequest user={user} emailChangeRequest={emailChangeRequest} />
      ) : (
        <UpdateEmailDialog user={user} />
      )}
    </>
  )
}

export default UserEmailSetting
